import React, { FC } from "react";
import Select, { components, SingleValueProps, OptionProps } from "react-select";
import "./../../assets/css/CustomSelect.css";
import CloudAddIcon from './../../assets/img/cloud-add.svg';
import EditIcon from './../../assets/img/edit-2.svg';
import GlobalIcon from './../../assets/img/global.svg';

interface Country {
  value: string;
  label: string;
}

interface CustomSelectProps {
  options: Country[];
  value: Country | null;
  onChange: (newValue: Country | null) => void;
  isClearable: boolean;
}

const getIcon = (value: string) => {
  const numericValue = parseInt(value, 10);
  if (numericValue === 0) return GlobalIcon;
  if (numericValue === -1) return EditIcon;
  return CloudAddIcon;
};

const Option: FC<OptionProps<Country>> = (props) => (
  <components.Option {...props} className="country-option">
    <img src={getIcon(props.data.value)} alt="icon" className="country-logo" />
    {props.data.label}
  </components.Option>
);

const SingleValue: FC<SingleValueProps<Country>> = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <img src={getIcon(props.data.value)} alt="s-logo" className="selected-logo" />
    {children}
  </components.SingleValue>
);



const CustomSelect: FC<CustomSelectProps> = ({ options, value, onChange, isClearable }) => (


<Select
  value={value}
  options={options}
  onChange={onChange}
  isClearable={isClearable}
  styles={{
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "auto",
    }),
    singleValue: (base) => ({
      ...base,
      display: "flex",
      alignItems: "center",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      position: "absolute",
      backgroundColor: "white",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      minHeight: "45px",
      backgroundColor: isSelected ? "#189394" : isFocused ? "#f0f0f0" : "white",
      color: isSelected ? "white" : "black",
      cursor: "pointer",
      transition: "background-color 0.2s ease-in-out",
    }),
  }}
  menuPortalTarget={document.body}
  components={{
    Option,
    SingleValue,
  }}
/>


);

export default CustomSelect;
